import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pickup-schedule',
  templateUrl: './pickup-schedule.component.html',
  styleUrls: ['./pickup-schedule.component.scss'],
})
export class PickupScheduleComponent implements OnInit {
  @Input() timeSlots: any[] = [];
  @Input() selectedTimeSlotId: string | null = null;
  @Input() isOutOfHours: boolean = false;
  @Input() collectionDateLabel: string = '';

  @Output() timeSlotSelected = new EventEmitter<any>();

  public selectedSlot: any | null = null;

  constructor() {}

  ngOnInit(): void {
    if (this.selectedTimeSlotId && this.timeSlots.length > 0) {
      this.selectedSlot =
        this.timeSlots.find((slot) => slot.id === this.selectedTimeSlotId) ||
        null;
    }
  }

  onTimeSlotClick(slot: any): void {
    this.selectedSlot = slot;
    this.timeSlotSelected.emit(slot);
  }

  isSelected(slotId: string): boolean {
    return this.selectedSlot?.id === slotId;
  }
}
